import request from '@/utils/request'

// 配置
export function getConfig() {
    return request.get({ url: '/index/config' })
}

// 获取上传参数
export function preUpload(type: string) {
    return request.post({ url: '/upload/' + type })
}

// 获取图片上传参数
export function imagePreUpload() {
    return request.post({ url: '/upload/image' })
}

// 获取视频上传参数
export function videoPreUpload() {
    return request.post({ url: '/upload/video' })
}

// 获取音频上传参数
export function audioPreUpload() {
    return request.post({ url: '/upload/audio' })
}
